export default "__VITE_ASSET__RldKMuFa__"